import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAbility from 'src/hooks/useAbility';

const AbilityGuard = ({ action, subject = 'all', children }) => {
  const ability = useAbility();

  if (!ability) {
    return null; // Or a loading spinner if preferred
  }

  const actions = Array.isArray(action) ? action : [action];
  const canAccess = actions.some((act) => ability.can(act, subject));

  if (!canAccess) {
    return <Redirect to="/app/dashboard" />;
  }

  return <>{children}</>;
};

AbilityGuard.propTypes = {
  action: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]).isRequired,
  subject: PropTypes.string,
  children: PropTypes.node.isRequired
};

export const withAbility = (action, Component) => {
  return (props) => (
    <AbilityGuard action={action}>
      <Component {...props} />
    </AbilityGuard>
  );
};

export default AbilityGuard;
